import { styled } from 'styled-components';

import { HOSPITAL_NAME } from '../../../../shared/env';

import { StyledTextField } from './Slot/TextFieldSlot';
import {
  HealthHubLogo as StyledHealthhubLogo,
  HospitalNameLogo as StyledHospitalLogo,
} from './styledComponents';

export const PasswordField = styled.div<{
  $icon?: string;
}>`
  ${StyledTextField} {
    background: url(${p => p.$icon}) no-repeat;
    background-size: 14px auto;
    background-position: right 10.44px center;
    padding-right: 40px;
  }
`;

export const VerificationButton = styled.button<{
  $outlined?: boolean;
  $invalid?: boolean;
}>`
  display: flex;
  width: 100%;
  height: ${p => (p.theme.isMobile ? '50px' : '37px')};
  justify-content: center;
  align-items: center;
  border: 1px solid;
  border-radius: 4px;
  border-color: ${p =>
    p.$invalid ? '#ff0000' : 'var(--HScan_Light_Blue, #2e5be0)'};
  color: var(--HScan_Light_Blue, #2e5be0);
  background: ${p => (p.$outlined ? p.theme.colors.white : '#2e5be0')};
  cursor: pointer;

  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${p => (p.$outlined ? '#2e5be0' : p.theme.colors.white)};

  &:disabled {
    background-color: #e8e8e8;
    color: #bdbdbd;
    border-color: #bdbdbd;
    cursor: not-allowed;
  }
`;

export const SlotContainer = styled.div`
  width: 100%;
  margin-top: 44px;
`;

export const RequirementListContainer = styled.div`
  padding: 10px;
  font-size: 12px;
  font-weight: 400;
`;

export const RequiredListWrapper = styled.div<{ $satisfied?: boolean }>`
  display: flex;
  align-items: center;
  padding: 3px 0;
  line-height: 18px;
  color: ${p => (p.$satisfied ? '#27a85f' : '#5a6473')};
  opacity: ${p => (p.$satisfied ? '1' : '0.5')};

  & > svg {
    align-self: start;
    height: 18px;
  }
`;

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 88px 0px 74px 0px;
  box-sizing: border-box;
  background-color: ${p => '#00025a' || p.theme.colors.primary};

  ${p =>
    p.theme.isMobile &&
    `
  padding: 0;
  `}
`;

export const SectionContainer = styled.div`
  display: flex;
  background: #ffffff;
  width: 575px;
  padding: 53px 85px;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  border-radius: 14px;

  ${p =>
    p.theme.isMobile &&
    `
    width: 100%;
    padding: 48px calc(max((100% - 405px) / 2, 27px)) 78px;
    border-radius: 0;
    `}
`;

export const HealthHubLogo = styled(StyledHealthhubLogo)`
  ${p =>
    p.theme?.isMobile &&
    `
  height: 25px;
  width: 140px;
  `}
`;

export const HospitalNameLogo = styled(StyledHospitalLogo)`
  ${p =>
    p.theme?.isMobile &&
    `
  width: fit-content;
  font-size: 25px; 
  line-height: 25px;
  `}
`;

export const HospitalLogo = () =>
  HOSPITAL_NAME ? (
    <HospitalNameLogo>{HOSPITAL_NAME}</HospitalNameLogo>
  ) : (
    <HealthHubLogo />
  );

export const SectionTitle = styled.div`
  margin-top: 27px;
  font-size: 18px;
  font-weight: 400;
  line-height: 35px;
  color: var(--HScan_Dark_Blue, #16172c);
  white-space: nowrap;
`;

export const MobileSectionTitle = styled.div`
  margin-top: 27px;
  font-weight: 700;
  color: var(--HScan_Light_Blue, #2e5be0);
`;

export const SectionFooter = styled.div`
  display: flex;
  width: 100%;
  margin-top: 42px;
  justify-content: space-between;
  align-items: center;

  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--HPACS_Text_Light_Grey, #a3a6ab);

  ${p =>
    p.theme.isMobile &&
    `
    flex-direction: column;
    row-gap: 22px;
    font-size: 14px;
    `}
`;

export const SectionFooterText = styled.span<{ $pointer?: boolean }>`
  color: #5a6473;
  white-space: nowrap;
  ${p => p.$pointer && 'cursor: pointer'};
`;

export const ErrorMessage = styled.div`
  width: 100%;
  height: 18px;
  margin-top: 24px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #ff5656;
`;
